import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";
import type { AssignRepToContacts } from "@/dtos/Contact.dto";

export interface AssignContactsParams {
  contactIds: string[];
  repId: string | null;
  organizationId: string;
}

/**
 * Composable for contact assignment mutations
 */
export function useContactAssignments() {
  const queryClient = useQueryClient();

  const assignMutation = useMutation({
    mutationFn: async (params: AssignContactsParams) => {
      const payload: AssignRepToContacts = {
        contactIds: params.contactIds,
        repId: params.repId,
        organizationId: params.organizationId,
      };
      const result = await Contact.assignRepToContacts(payload);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to assign contacts");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
    },
  });

  return {
    assignContacts: assignMutation.mutateAsync,
    isAssigning: assignMutation.isPending,
    assignError: assignMutation.error,
  };
}
